"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcContractEvents = class UcContractEvents extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_contract_protocol', {
            parameters: {
                contract_id: this.contract.id,
                contract_revision_id: this.contract.revision_id
            }
        })
            .then(d => _.orderBy(d, ['handover_date'], ['desc']));
    }
    ux;
    dataMembers = ['items', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async evh_4440454779651433_close_8805_getWhen($event) {
        return $event.data.modalResult && $event.data.modalResult.ok;
    }
    async act_4440454779651433_showModal_8804_getActionArgs($event) {
        return {
            name: "HandoverProtocol",
            props: {
                contractId: this.contract.id,
                revisionId: this.contract.revision_id,
                handoverType: "moving_in",
            },
        };
    }
    async evh_4440454779651433_clickPreventStop(event, scope) {
        return await this.actions.evh_4440454779651433_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_8643180786190723_close_8809_getWhen($event) {
        return $event.data.modalResult && $event.data.modalResult.ok;
    }
    async act_8643180786190723_showModal_8808_getActionArgs($event) {
        return {
            name: "HandoverProtocol",
            props: {
                contractId: this.contract.id,
                revisionId: this.contract.revision_id,
                handoverType: "moving_out",
            },
        };
    }
    async evh_8643180786190723_clickPreventStop(event, scope) {
        return await this.actions.evh_8643180786190723_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_2002045350107722_close_8813_getWhen($event) {
        return $event.data.modalResult && $event.data.modalResult.ok;
    }
    async act_2002045350107722_showModal_8812_getActionArgs($event) {
        return {
            name: "HandoverProtocol",
            props: {
                oid: $event.scope.item.id,
            },
        };
    }
    async evh_2002045350107722_clickPreventStop(event, scope) {
        return await this.actions.evh_2002045350107722_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8802 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8801 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8802,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8801],
        });
        const act_4440454779651433_reloadComponentData_8806 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_4440454779651433_close_8805 = new core_1.actions.EventHandlerImpl({
            action: act_4440454779651433_reloadComponentData_8806,
            event: "close",
            when: this.evh_4440454779651433_close_8805_getWhen,
            displayName: "reloadComponentData",
        });
        const act_4440454779651433_showModal_8804 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4440454779651433_showModal_8804_getActionArgs,
            events: [evh_4440454779651433_close_8805],
        });
        const evh_4440454779651433_clickPreventStop_8803 = new core_1.actions.EventHandlerImpl({
            action: act_4440454779651433_showModal_8804,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_4440454779651433_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4440454779651433_clickPreventStop_8803],
        });
        const act_8643180786190723_reloadComponentData_8810 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8643180786190723_close_8809 = new core_1.actions.EventHandlerImpl({
            action: act_8643180786190723_reloadComponentData_8810,
            event: "close",
            when: this.evh_8643180786190723_close_8809_getWhen,
            displayName: "reloadComponentData",
        });
        const act_8643180786190723_showModal_8808 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8643180786190723_showModal_8808_getActionArgs,
            events: [evh_8643180786190723_close_8809],
        });
        const evh_8643180786190723_clickPreventStop_8807 = new core_1.actions.EventHandlerImpl({
            action: act_8643180786190723_showModal_8808,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8643180786190723_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8643180786190723_clickPreventStop_8807],
        });
        const act_2002045350107722_reloadComponentData_8814 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2002045350107722_close_8813 = new core_1.actions.EventHandlerImpl({
            action: act_2002045350107722_reloadComponentData_8814,
            event: "close",
            when: this.evh_2002045350107722_close_8813_getWhen,
            displayName: "reloadComponentData",
        });
        const act_2002045350107722_showModal_8812 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2002045350107722_showModal_8812_getActionArgs,
            events: [evh_2002045350107722_close_8813],
        });
        const evh_2002045350107722_clickPreventStop_8811 = new core_1.actions.EventHandlerImpl({
            action: act_2002045350107722_showModal_8812,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_2002045350107722_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2002045350107722_clickPreventStop_8811],
        });
        return {
            act_7315092382398562_reloadComponentData_8802,
            evh_7315092382398562_reload_8801,
            evh_7315092382398562_reload,
            act_4440454779651433_reloadComponentData_8806,
            evh_4440454779651433_close_8805,
            act_4440454779651433_showModal_8804,
            evh_4440454779651433_clickPreventStop_8803,
            evh_4440454779651433_clickPreventStop,
            act_8643180786190723_reloadComponentData_8810,
            evh_8643180786190723_close_8809,
            act_8643180786190723_showModal_8808,
            evh_8643180786190723_clickPreventStop_8807,
            evh_8643180786190723_clickPreventStop,
            act_2002045350107722_reloadComponentData_8814,
            evh_2002045350107722_close_8813,
            act_2002045350107722_showModal_8812,
            evh_2002045350107722_clickPreventStop_8811,
            evh_2002045350107722_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractEvents.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractEvents.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcContractEvents.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractEvents.prototype, "onReadonly", null);
UcContractEvents = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcContractEvents);
exports.default = UcContractEvents;
vue_property_decorator_1.Vue.component("UcContractEvents", UcContractEvents);
